var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWspLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 647.2 380",
    style: {
      enableBackground: "new 0 0 647.2 380"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M507.7,164.4c0-23.1-8.4-42.3-19.5-54.9h32.1c10.5,12.8,17,34.6,17,54.9v0.1c0,20.3-6.5,42.2-17.1,55h-32.1 C499.2,206.8,507.7,187.6,507.7,164.4L507.7,164.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.5,109.5 110,109.5 150.5,219.5 166.2,219.5 173.1,200.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.8,109.5 189.2,109.5 229.8,219.5 245.5,219.5 252.4,200.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.5,312.7 444.5,209.2 444.5,206.5 444.5,198.3 444.5,126.8 444.5,121.1 444.5,117.8 444.5,109.5 416.2,109.5  416.2,198.3 416.2,312.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,125.8c0.5-5.6,1.5-11.2,3.8-16.3h25.9c-2.2,3.9-4.2,11-1.9,18.1c2.1,6.4,6.5,10.7,12.1,14.3 c6.6,4.3,14.3,6.6,21.4,9.9c7.4,3.5,14.6,7.1,20.8,12.5c9,7.8,14.5,17.1,15.4,29.1c0.1,1.4,0.2,2.9,0.2,4.3c0,7.5-1.2,15-4.5,21.7 h-26.6c2.6-4.4,4.7-10.5,4.3-16.1c-0.9-13.9-17.9-21.4-32-27.7c-2.2-1-4.3-1.9-6.3-2.9c-6.2-2.9-12.3-6.3-17.7-10.7 c-5.5-4.6-9.7-9.1-12.2-15.8c-2.2-5.9-3.1-12.2-2.8-18.5C282.3,127.1,282.3,126.5,282.4,125.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWspLogoBlack);
export default __webpack_public_path__ + "static/media/wsp_logo_black.0e5f3a903169f126006dd4b86b3ab4ea.svg";
export { ForwardRef as ReactComponent };